import { render, staticRenderFns } from "./agencias.vue?vue&type=template&id=5b260670&scoped=true&"
import script from "./agencias.vue?vue&type=script&lang=js&"
export * from "./agencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b260670",
  null
  
)

export default component.exports